import { memo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
// import { useNavigate } from "react-router-dom";

NoDataToDisplay(Highcharts);

const sampleData = [
    {name: '387749', value: 456}, 
    {name: '280000', value: 56},
    {name: '35235', value: 156}, 
    {name: '129000', value: 356}, 
    {name: '64300', value: 262}, 
    {name: '54000', value: 356}, 
    {name: '34300', value: 196}]

const sampleFieldDetails = {
    nameField: 'name',
    valueField: 'value',
    units: ''
}

const SimpleBarChart = memo(({title, 
    data, 
    legendName="", 
    seriesColor="#20bd41",
    chartHeight=200,
    fieldDetails=sampleFieldDetails,
    toolTipUrl}) => {
  
    // const navigate = useNavigate();
    data =  data?.length ? data : sampleData;

    const namesArray = data?.map((item, index) => {
        return (item[fieldDetails?.nameField]?.toString())
    })
    const valuesArray = data?.map((item, index) => {
        return (item[fieldDetails?.valueField])
    })

    const getOptions = {
        chart: {
            type: 'column',
            height: chartHeight,
            marginBottom: 60
        },
        title: {
            text: title,
            align: 'left',
            margin: 30,
            style: {
                fontSize: '14px',
                fontWeight: 'bold',
            }
        },
        xAxis: {
            // type: 'category',
            categories: namesArray,
            labels: {
                formatter: function() {
                    const len = this?.value?.length;
                    if (len > 4) {
                        return '...' + this?.value?.substr(len-4, 4) 
                    } else {
                        return this?.value
                    }
                },
                rotation: 0,
                autoRotation: false
            },
            crosshair: false,
            style: {
                fontSize: '10px',
                fontWeight: 'normal'
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: null,
            },
            labels:{
                style: {
                    fontSize: '10px',
                    fontWeight: 'normal'
                }
            }
        },
        legend: {
            enabled: true,
            align: 'left',
            y: 22,
            itemStyle: {
                fontSize: '12px',  
                fontWeight: 'normal' 
            }
        },
        lang: {
            noData: 'No data for the selected time range'
        },
        noData: {
            useHTML: true,
            style: {
            fontSize: '14px',
            fontWeight: 'normal',
            color: '#8a8a8a', // color of no data message
            },
        },
        tooltip: {
            backgroundColor: "#fafafa",
            borderWidth: 0,
            height: 80,
            padding: 8,
            valueSuffix: '',
            useHTML: true,
            formatter: function () {
                let xLabel = this.series.chart.xAxis[0].categories[this.point.index];
                let yValue = this.y
                return `<div class="text-center" id="tooltip-xlabel"> 
                        <span>${xLabel}</span><br/>
                        <b>${yValue} ${fieldDetails.units}</b></div>`;
                }
        },
        credits: {
            enabled: false,
        },
        exporting: {
            enabled: false,
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [
            {
                dataLabels: {
                    enabled: false,
                },
                name: legendName,
                data: valuesArray,
                color: seriesColor
            },
        ]
    };

    // const handleTooltipClick = (value) =>  {
    //     console.log('click')
    //     navigate(navigateUrl, { state: { imei: value } });
    // }

    return (
        <HighchartsReact highcharts={Highcharts} options={getOptions} />
    )
});

export default SimpleBarChart;
